import {
  ADD_USER,
  DELETE_COMPANY_USER, HANDLE_ACCOUNT_UPDATED, HANDLE_CHANGED_PASSWORD, SET_COMPANY_USERS, SET_ERRORS, SET_USER,
  SET_USER_ADDED
} from "../actions/actionTypes";

const initialState = {
  users: {},
  userAdded: false,
  errors: null,
  passwordChanged: false,
  accountUpdated: true
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANY_USERS:
      return {
        ...state,
        users: action.payload
      };
    case SET_USER:
      return {
        ...state,
        users: {
          ...state.users,
          company_users: state.users.company_users.map(user => (user.user.id === action.payload.id) ? {
            ...user,
            user: action.payload
          } : user),
          warehouseAdmins: state.users.warehouseAdmins.map(user => (user.user.id === action.payload.id) ? {
            ...user,
            user: action.payload
          } : user)
        }
      };
    case DELETE_COMPANY_USER:
      return {
        ...state,
        users: {
          ...state.users,
          company_users: state.users.company_users.filter(user => user.user.id !== action.payload),
          warehouseAdmins: state.users.warehouseAdmins.filter(user => user.user.id !== action.payload)
        }
      };
    case SET_USER_ADDED:
      return {
        ...state,
        userAdded: action.payload
      };
    case SET_ERRORS:
      return {
        ...state,
        errors: action.payload
      };
    case HANDLE_CHANGED_PASSWORD:
      return {
        ...state,
        passwordChanged: action.payload.response ? action.payload.response : action.payload
      };
    case HANDLE_ACCOUNT_UPDATED:
      return {
        ...state,
        accountUpdated: action.payload
      };
    case ADD_USER:
      return {
        ...state,
        users: {
          ...state.users,
          invited_warehouse_admins: state.users.invited_warehouse_admins.concat(action.payload)
        }
      };
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/user.js